import Cookies from "js-cookie";
import base64 from "base-64";

const dlrCookieName = "dlr";

const setEmailCookie = (formElement) => {
    if (!formElement.classList.contains(dlrCookieName)) return;

    const emailField = formElement.querySelector("#Email");

    if (emailField && emailField.value) Cookies.set(dlrCookieName, base64.encode(emailField.value));
};

export const removeDlrCookie = () => {
    if (document.querySelector(".removeDlr")) Cookies.remove(dlrCookieName);
};

export default function(formElement) {
    formElement.addEventListener("submit", setEmailCookie.bind(null, formElement));
}
